// TODO: BTBPSDL-200 remove getRadiusValue once AB test will complete
export const getRadiusValue = (variationKey: string | null): string => {
  if (variationKey === 'fifteen_km') {
    return '15000'
  }
  if (variationKey === 'twenty_km') {
    return '20000'
  }
  if (variationKey === 'thirty_km') {
    return '30000'
  }
  return '10000'
}
